import { Component, OnInit } from "@angular/core";
import { NgxSpinnerModule } from "ngx-spinner";

@Component({
    selector: "app-custom-spinner",
    templateUrl: "./custom-spinner.component.html",
    styleUrls: ["./custom-spinner.component.scss"],
    imports: [NgxSpinnerModule]
})
export class CustomSpinnerComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
